import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { User, ShoppingBag, MapPin, Key, LogOut } from 'lucide-react';

const UserSidebar = ({ user }) => {
    const location = useLocation();

    const userInfo = user || JSON.parse(localStorage.getItem('user_info') || '{}');
    const displayName = userInfo?.fullName || userInfo?.accountName || userInfo?.username || 'Thành viên';
    const initial = displayName.charAt(0).toUpperCase();

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_info');
        window.location.href = '/'; 
    };

    return (
        <div className="w-full md:w-64 flex-shrink-0 bg-gradient-to-b from-orange-50 to-white rounded-xl shadow-sm border border-orange-200/60 p-4 h-fit">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-orange-200/60">
                <div className="w-12 h-12 bg-gradient-to-br from-tnc-orange to-tnc-orange-hover rounded-full flex items-center justify-center text-white font-bold text-xl shadow-md border-2 border-white uppercase flex-shrink-0">
                    {initial}
                </div>
                <div className="overflow-hidden">
                    <p className="font-bold text-gray-800 line-clamp-1">{displayName}</p>
                </div>
            </div>
            
            <nav className="space-y-1">
                <Link to="/profile" className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors ${location.pathname === '/profile' ? 'bg-orange-100/80 text-tnc-orange font-bold' : 'text-gray-600 hover:bg-orange-50 hover:text-tnc-orange'}`}>
                    <User size={18} /> Hồ sơ cá nhân
                </Link>
                <Link to="/my-orders" className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors ${location.pathname === '/my-orders' ? 'bg-orange-100/80 text-tnc-orange font-bold' : 'text-gray-600 hover:bg-orange-50 hover:text-tnc-orange'}`}>
                    <ShoppingBag size={18} /> Quản lý đơn hàng
                </Link>
                <Link to="/profile/addresses" className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors ${location.pathname === '/profile/addresses' ? 'bg-orange-100/80 text-tnc-orange font-bold' : 'text-gray-600 hover:bg-orange-50 hover:text-tnc-orange'}`}>
                    <MapPin size={18} /> Sổ địa chỉ
                </Link>
                <Link to="/profile/password" className={`flex items-center gap-3 px-4 py-2.5 rounded-lg transition-colors ${location.pathname === '/profile/password' ? 'bg-orange-100/80 text-tnc-orange font-bold' : 'text-gray-600 hover:bg-orange-50 hover:text-tnc-orange'}`}>
                    <Key size={18} /> Đổi mật khẩu
                </Link>
            </nav>
            
            <div className="mt-6 pt-4 border-t border-orange-200/60">
                <button onClick={handleLogout} className="flex items-center w-full gap-3 px-4 py-2.5 rounded-lg text-red-600 font-bold hover:bg-red-50 transition-colors">
                    <LogOut size={18} /> Đăng xuất
                </button>
            </div>
        </div>
    );
};

export default UserSidebar;